// mui
import { Box } from '@mui/material';

// assets
// @transform-path ../../../../../../src/assets/logo/logo-text-primary.svg
import logoTextPrimary from '@/assets/logo/logo-text-primary.svg';
// @transform-path ../../../../../../src/assets/logo/logo-text-secondary.svg
import logoTextSecondary from '@/assets/logo/logo-text-secondary.svg';
// @transform-path ../../../../../../src/assets/logo/logo-text-white.svg
import logoTextWhite from '@/assets/logo/logo-text-white.svg';
// @transform-path ../../../../../../src/assets/logo/logo-symbol-primary.svg
import logoSymbolPrimary from '@/assets/logo/logo-symbol-primary.svg';
// @transform-path ../../../../../../src/assets/logo/logo-symbol-secondary.svg
import logoSymbolSecondary from '@/assets/logo/logo-symbol-secondary.svg';
// @transform-path ../../../../../../src/assets/logo/logo-symbol-white.svg
import logoSymbolWhite from '@/assets/logo/logo-symbol-white.svg';

const logoSymbolMap = {
  primary: logoSymbolPrimary,
  secondary: logoSymbolSecondary,
  white: logoSymbolWhite,
};

const logoTextMap = {
  primary: logoTextPrimary,
  secondary: logoTextSecondary,
  white: logoTextWhite,
};

const heightMap = {
  sm: 16,
  md: 24,
  lg: 38,
};

type LogoSize = 'sm' | 'md' | 'lg';
type LogoVariant = 'full' | 'symbol' | 'text';
type LogoColor = 'primary' | 'secondary' | 'white';

interface LogoProps {
  size?: LogoSize;
  variant?: LogoVariant;
  color?: LogoColor;
}

/**
 * Logo displays the KareHero logo.
 */
export const Logo = ({
  size = 'md',
  variant = 'text',
  color = 'primary',
}: LogoProps) => (
  <Box
    sx={{
      display: 'flex',
      gap: 1,
      alignItems: 'center',
      height: heightMap[size],
      maxHeight: heightMap[size],
      minHeight: heightMap[size],

      '& img': {
        objectFit: 'contain',
        height: '100%',
      },
    }}
  >
    {(variant === 'symbol' || variant === 'full') && (
      <img src={logoSymbolMap[color]} alt='logo symbol' />
    )}
    {(variant === 'text' || variant === 'full') && (
      <img src={logoTextMap[color]} alt='logo text' />
    )}
  </Box>
);

Logo.displayName = 'Logo';

export default Logo;
